import router from "@/router";
import appApi from "@/api/appApi";
import appSocket from "@/setup/io";
import authSerivce from "@/services/auth";
import showProfile from "@/services/common/showProfile";

window.appApi = appApi;

const state = {
  token: localStorage.getItem("user-token") || "",
  status: null,
  newbie: true,
  referee: false,
  currentUser: null
};

const getters = {
  authStatus: s => s.status,
  isAuthenticated: s => !!s.currentUser,
  isRegistred: s => s.referee || !s.newbie,
  isReferee: s => s.referee,
  user: s => s.currentUser
};

const mutations = {
  AUTH_REQUEST(state) {
    state.status = "loading";
  },
  AUTH_SUCCESS(state, user) {
    state.status = "success";
    state.currentUser = user;
  },
  AUTH_ERROR(state) {
    state.status = "error";
  },
  AUTH_LOGOUT(state) {
    state.token = "";
    state.currentUser = null;
    state.newbie = true;
    state.referee = false;
  },
  SET_TOKEN(state, newValue) {
    state.token = newValue;
  },
  SET_ROLE(state, { newbie, referee }) {
    state.newbie = newbie;
    state.referee = referee;
  }
};

const actions = {
  async init({ state, dispatch }) {
    if (state.token) {
      setDefaultAuthHeaders(state.token);
      await dispatch("getProfile");
    }
  },

  // async login({ state, commit, dispatch, rootState }) {
  //   const accepted = await showProfile(state.currentUser);
  //   if (!accepted) return;

  async login({ commit, dispatch, rootState }) {
    try {
      const token = await authSerivce.login();
      localStorage.setItem("user-token", token);
      commit("SET_TOKEN", token);
      setDefaultAuthHeaders(token);

      await dispatch("getProfile");
      router.push(rootState.route.path);

      return !!token;
    } catch {
      console.log("Steam auth window closed manually");
    }
  },

  logout({ commit, dispatch }) {
    commit("AUTH_LOGOUT");
    localStorage.removeItem("user-token");
    setDefaultAuthHeaders();
    dispatch("wsTriggerReconnect");
    router.push({ name: "home" });
  },

  async getProfile({ commit, dispatch }) {
    commit("AUTH_REQUEST");
    try {
      const user = await authSerivce.getProfile();
      commit("AUTH_SUCCESS", user);

      let newbie = await authSerivce.checkIsNewbie();
      let referee = !newbie ? await authSerivce.checkIsReferee() : false;

      commit("SET_ROLE", { newbie, referee });
      dispatch("wsTriggerReconnect");

      if (newbie) {
        const accepted = await authSerivce.showProfile(user);
        if (!accepted) return dispatch("logout");
      }

      return user;
    } catch {
      commit("AUTH_ERROR");
      return dispatch("logout");
    }
  },

  async openProfile({ state, getters }) {
    await showProfile(state.currentUser, getters.isRegistred);
  },

  wsTriggerReconnect({ state }) {
    appSocket.close();
    setTimeout(() => {
      if (state.token) {
        appSocket.io.opts.query = { token: state.token };
      }
      appSocket.open();
    }, 10);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

function setDefaultAuthHeaders(token) {
  if (token) {
    appApi.defaults.headers.common.Authorization = "Bearer " + token;
  } else {
    delete appApi.defaults.headers.common.Authorization;
  }
}
